export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13200.aa9cb0b7.jpg";